import BaseReduction from './BaseReduction';

export default class DividendReduction extends BaseReduction {
  constructor() {
    super(...arguments);
    this.ensureArray('tippedWinners');
    this.ensureInteger('minDividend', -1);
    this.ensureInteger('maxDividend', -1);
    this.ensureInteger('v6MinDividend', -1);
    this.ensureInteger('v6MaxDividend', -1);
    this.ensureInteger('v7MinDividend', -1);
    this.ensureInteger('v7MaxDividend', -1);
  }

  isEmpty() {
    if (
      this.getMinDividend() < 0 &&
      this.getMaxDividend() < 0 &&
      this.getV6MinDividend() < 0 &&
      this.getV6MaxDividend() < 0 &&
      this.getV7MinDividend() < 0 &&
      this.getV7MaxDividend() < 0 &&
      this.getTargetWin() < 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  reset() {
    const tippedWinners = this.data.tippedWinnerNumbers;
    super.reset();
    this.data.tippedWinnerNumbers = tippedWinners;
  }

  getTippedWinners() {
    return this.getIntegerArray('tippedWinners');
  }
  setTippedWinners(v) {
    this.invalidate();
    return this.setIntegerArray('tippedWinners', v);
  }
  getJackpot() {
    return this.getInteger('jackpot');
  }
  getEstimatedCount() {
    return this.getInteger('estimatedCount');
  }
  getEstimatedDividend() {
    return this.getInteger('estimatedDividend');
  }

  getMinDividend() {
    return this.getInteger('minDividend', -1);
  }
  setMinDividend(v) {
    this.invalidate();
    return this.setInteger('minDividend', v);
  }

  getMaxDividend() {
    return this.getInteger('maxDividend', -1);
  }
  setMaxDividend(v) {
    this.invalidate();
    return this.setInteger('maxDividend', v);
  }

  setV6MinDividend(v) {
    this.invalidate();
    return this.setInteger('v6MinDividend', v);
  }
  getV6MinDividend() {
    return this.getInteger('v6MinDividend', -1);
  }

  setV6MaxDividend(v) {
    this.invalidate();
    return this.setInteger('v6MaxDividend', v);
  }
  getV6MaxDividend() {
    return this.getInteger('v6MaxDividend', -1);
  }

  setV7MinDividend(v) {
    this.invalidate();
    return this.setInteger('v7MinDividend', v);
  }
  getV7MinDividend() {
    return this.getInteger('v7MinDividend', -1);
  }

  setV7MaxDividend(v) {
    this.invalidate();
    return this.setInteger('v7MaxDividend', v);
  }
  getV7MaxDividend() {
    return this.getInteger('v7MaxDividend', -1);
  }

  getDividendTippedWinner(row) {
    const tippedWinner = this.getIntegerAt('tippedWinnerNumbers', row);
    if (tippedWinner == null) {
      this.setDividendTippedWinner(row, 1);
    }

    return this.getIntegerAt('tippedWinnerNumbers', row);
  }
  setDividendTippedWinner(index, v) {
    this.invalidate();
    return this.setIntegerAt('tippedWinnerNumbers', index, v);
  }
  setDividendTippedWinners(v) {
    this.invalidate();
    return this.setIntegerArray('tippedWinnerNumbers', v);
  }
  isDividendTippedWinner(row, startNumber) {
    const tippedArray = this.getIntegerArray('tippedWinnerNumbers');
    return tippedArray[row] === startNumber;
  }
  setMaxAllowedErrors(v) {
    this.invalidate();
    return this.setInteger('payoutNumberOfErrors', v);
  }
  getMaxAllowedErrors() {
    return this.getInteger('payoutNumberOfErrors', 0);
  }
  setTargetWin(v) {
    this.invalidate();
    return this.setInteger('targetWin', v);
  }
  getTargetWin() {
    return this.getInteger('targetWin', -1);
  }
}
